import {
  FOOTER_DETAILS_PAGE_REQUEST,
  FOOTER_DETAILS_PAGE_SUCCESS,
  FOOTER_DETAILS_PAGE_FAILURE
} from '../../constants'

const initialState = {
  data: {},
  isLoading: true,
  error: null
}

const FooterPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case FOOTER_DETAILS_PAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }

    case FOOTER_DETAILS_PAGE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null
      }

    case FOOTER_DETAILS_PAGE_FAILURE:
      return { ...state, isLoading: false, error: action.payload }

    default:
      return state
  }
}

export default FooterPageReducer
